import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Index = () => {

    const { id } = useParams();
    const { readData } = useEntityCrud('Guild/GetAllSubGuilds?guildId=' + id);
    const { addData: updateData } = useEntityCrud('Guild/ChangeSubGuildStatus');
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();

    const getData = () => {
        readData().then(({ data }) => {
            if (data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getData();
        localStorage.setItem("subGuilds" , id)
    }, []);

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت صنف مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت صنف مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }
    const handleBack = () => {
        navigate('/guilds',{replace: true});
        window.localStorage.removeItem("subGuilds")
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">زیر صنف ها</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                {rows.length ? <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>وضعیت</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
                                <td className="btn-list">
                                    <Link to={'/guilds/sub-guilds/update/' + item.id} className="btn btn-icon mb-0 btn-primary"><i className="fe fe-edit-2"></i></Link>
                                    {item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success"><i className="fe fe-check"></i></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> : <div className="alert alert-info"><p>داده ای یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;